function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (previousValue === '1' && event.target.name === 'minus') {
      this.input.value = 0;
      const cartItem = this.closest('.CartItem');
      
      const carItemRemove = cartItem.querySelector('cart-remove-button');
      if (carItemRemove) carItemRemove.click();
      return;
    }


    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, input[type="radio"]:checked'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);

    if (mediaGallery) mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const oneTimePrice = html.getElementById('one-time-price')
        const subscriptionPrice = html.getElementById('selling-plan-price')
  
        if (subscriptionPrice !== null) {
          document.getElementById('one-time-price').innerHTML = oneTimePrice.innerHTML
          document.getElementById('selling-plan-price').innerHTML = subscriptionPrice.innerHTML
        }

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > [add-to-cart-text]');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


class SwiperSlider extends HTMLElement {
  constructor() {
    super();
    this.initSlider()
    this.slider = this;
  }
  
  initSlider() {
    const sliderData = JSON.parse(this.getAttribute('data-swiper-options'))
    
    if (this.getAttribute('data-thumbnails')) {
      const thumbnails_element = document.getElementById(this.getAttribute('data-target')) ||  document.querySelector('.product-thumbnails')
      const thumbnails_options = JSON.parse(this.getAttribute('data-thumbnails'))
      const thumbnailsSwiper = new Swiper(thumbnails_element, thumbnails_options)
      
      sliderData.thumbs = {
        swiper: thumbnailsSwiper,
        autoScrollOffset: 1
      }
    }

    if (this.classList.contains('content-slider')) {
      const mainSlider = this
      
      sliderData.on =  {
        slideChange: function (slider) {
          const $currentSlide = $(mainSlider).find(`[data-swiper-slide-index="${slider.realIndex}"]`)
          
          $(mainSlider).find('.swiper-slide').removeClass('swiper-slide-nth-prev-2 swiper-slide-nth-next-2');
          $currentSlide.prev().prev().addClass('swiper-slide-nth-prev-2');
          $currentSlide.next().next().addClass('swiper-slide-nth-next-2');
  
          setTimeout(function () {
            $(mainSlider).parents('.content-slideshow').css('background-color', $currentSlide.attr('data-color'))
          }, 900)
        }
      }
    }
    
    const swiper = new Swiper(this, sliderData)
  }
}

customElements.define('swiper-slider', SwiperSlider);


class CartDrawer extends HTMLElement {
  constructor() {
    super();
    
    this.cartDrawer = document.getElementById('sidebar-cart')
    this.header = document.querySelector('sticky-header')
    this.onBodyClick = this.handleBodyClick.bind(this)
    this.cartIcon = document.querySelector('#cart-icon-bubble')
    this.cartScrollable = document.querySelector('[data-scrollable]')
    this.pageOverlay = document.querySelector('.PageOverlay')
    
    this.cartIcon.addEventListener('click', (e) => {
      e.preventDefault();
      this.open();
    })
    
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    this.querySelectorAll('[data-action="close-cart"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    
    if (new URLSearchParams(location.search).has('cart')) {
      var urlParams = new URLSearchParams(location.search);
      urlParams.delete('cart');
      
      history.replaceState(null, null, location.href.replace(location.search, '?' + urlParams));
      this.open()
    }
  }
  
  open() {
    this.pageOverlay.classList.add('is-visible')
    this.cartDrawer.setAttribute('aria-hidden', 'false');
    
    bodyScrollLock.disableBodyScroll(this.cartScrollable)
    
    
    this.cartDrawer.addEventListener('transitionend', () => {
      this.cartDrawer.focus();
      trapFocus(this.cartDrawer);
    }, { once: true });
    
    document.body.addEventListener('click', this.onBodyClick);
  }
  
  close() {
    this.cartDrawer.setAttribute('aria-hidden', 'true');
    this.pageOverlay.classList.remove('is-visible')
    
    document.body.removeEventListener('click', this.onBodyClick);
    
    removeTrapFocus(this.activeElement);
    
    bodyScrollLock.clearAllBodyScrollLocks()
  }
  
  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this && !target.closest('cart-drawer') && !target.closest('#cart-icon-bubble')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }
  
  renderCart(responseHTML, openCart) {
    if (!responseHTML) {
      return
    }
    
    const cartBody = document.querySelector('.Drawer__CartListWrapper')
    const cartHeader = document.querySelector('.Drawer__CartHeaderTitle')
    const freeShippingMessage = document.querySelector('.FreeShipping__Message')
    const progressLine = document.querySelector('.FreeShipping__ProgressLine')
    const cartFooter = document.querySelector('.Drawer__Footer')
    const cartBodyNew = responseHTML.querySelector('.Drawer__CartListWrapper').innerHTML
    const cartHeaderNew = responseHTML.querySelector('.Drawer__CartHeaderTitle').innerHTML
    const freeShippingMessageNew = responseHTML.querySelector('.FreeShipping__Message')?.innerHTML
    const progressLineNew = responseHTML.querySelector('.FreeShipping__ProgressLine')?.getAttribute('style')
    const cartFooterNew = responseHTML.querySelector('.Drawer__Footer')
    const cartCountNew = responseHTML.getElementById('item-count')
    const cartCountBubble = document.querySelector('.header__icon .cart-count-bubble')
    
    if (cartCountNew !== null) {
      cartCountBubble.style.display = 'block'
      
      cartCountBubble.querySelector('[aria-hidden="true"]').innerHTML = cartCountNew.getAttribute('data-count')
    } else {
      cartCountBubble.style.display = 'none'
    }
    
    cartBody.innerHTML = cartBodyNew
    cartHeader.innerHTML = cartHeaderNew
    
    if (freeShippingMessage) {
      freeShippingMessage.innerHTML = freeShippingMessageNew
      progressLine.style = progressLineNew
    }
    
    if (cartFooter == null) {
      document.querySelector('.Drawer__CartWrapper').append(cartFooterNew)
    } else {
      if (cartFooterNew !== null) {
        cartFooter.innerHTML = cartFooterNew.innerHTML
        cartFooter.style.display = 'block'
      } else {
        cartFooter.style.display = 'none'
      }
    }
    
    if (openCart) {
      this.open()
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartNote extends HTMLElement {
  constructor() {
    super();
      this.querySelector('.Drawer__CartNote--Save').addEventListener('click', this.updateNote.bind(this));
  }
  
  updateNote(e) {
    e.preventDefault();
    $(e.target).parent().slideToggle()
  
    const config = fetchConfig('javascript')
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    
    config.body = JSON.stringify({
      note: this.querySelector('#CartSpecialInstructions').value,
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    });
    
    
    fetch(`${routes.cart_update_url}`, config)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        const cartHTML = new DOMParser().parseFromString(json.sections['cart-drawer'], 'text/html');
  
        this.closest('cart-drawer').renderCart(cartHTML, false)
      })
      .catch((error) => {
        console.error(error);
      })
  }
}

customElements.define('cart-note', CartNote);

class CartItems extends HTMLElement {
  constructor() {
    super()
    
    this.addEventListener('change', this.updateQuantity.bind(this))
    this.addEventListener('click', function (e) {
      const addProduct = e.target.closest('.recommended-product__add')
      if (!addProduct) return;
      e.preventDefault();
  
      const variantId = addProduct.getAttribute('data-variant-id')
      const sectionsId = 'cart-drawer'
      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
  
      config.body = JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1
          }
        ],
        sections: sectionsId,
        sections_url: window.location.pathname
      });
  
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          const cartHTML = new DOMParser().parseFromString(json.sections[sectionsId], 'text/html');
      
          this.cartDrawer.renderCart(cartHTML, false)
        })
        .catch((error) => {
          console.error(error);
        })
      
    })
    this.cartDrawer = document.querySelector('cart-drawer')
  }
  
  updateQuantity(event) {
    event.preventDefault()
    
    const sectionsId = 'cart-drawer'
    const config = fetchConfig('javascript')
    const id = event.target.getAttribute('data-line-key')
    let quantity
    
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    
    if (event.target.tagName === 'INPUT') {
      quantity = parseInt(Math.max(parseInt(event.target.value) || 1, 1));
    } else {
      quantity = parseInt(event.target.getAttribute('data-quantity'));
    }
    
    config.body = JSON.stringify({
      updates: {
        [id]: quantity,
      },
      sections: sectionsId,
      sections_url: window.location.pathname
    });
    
    fetch(`${routes.cart_update_url}`, config)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        const cartHTML = new DOMParser().parseFromString(json.sections[sectionsId], 'text/html');
        
        this.cartDrawer.renderCart(cartHTML, false)
      })
      .catch((error) => {
        console.error(error);
      })
  }
}

customElements.define('cart-items', CartItems);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      this.closest('cart-items').updateQuantity(event, false);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class KlaviyoSubscribe extends HTMLElement {
  constructor() {
    super();
    this.list_id = this.dataset.listId;
    this.dataset.klaviyo !== 'false' ? this.hasKlaviyo = true : this.hasKlaviyo = false;
    this.form = this.querySelector('form');
    this.input = this.form.querySelector('input[type="email"]');
    this.submit = this.form.querySelector('[type="submit"]');
    this.errorWrapper = this.form.querySelector('.email__error');
    this.error = this.form.querySelector('.error__text');
    this.success = this.form.querySelector('.email__input-success');
    this.wrapper = this.form.querySelector('.email__form-wrapper');
    this.companyId = 'XsLbxY';
  
    if (this.hasKlaviyo) {
      this.form.addEventListener('submit', this.klaviyoFormSubmit.bind(this));
    }
    
    this.input.addEventListener('input', () => this.hideError());
  }

  formData() {
    return {
      method: 'POST',
      headers: {revision: '2024-02-15', 'content-type': 'application/json'},
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Klaviyo form',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: (this.querySelector('input[type="email"]')) ? this.querySelector('input[type="email"]').value : '',
                }
              }
            }
          },
          relationships: {list: {data: {type: 'list', id: this.list_id}}}
        }
      })
    };
  }
  
  klaviyoFormSubmit(evt) {
    evt.preventDefault()

    if (this.list_id === '') {
      this.showError(window.newsletterStrings.klaviyoError);
    }

    if (!this.inputValidation()) return;

    const _this = this;

    fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}`, this.formData())
      .then(response => {(response.status === 202) ? _this.showSuccess() : _this.showError()})
      .catch(err => {console.error(err); _this.showError()});
  }
  
  showSuccess() {
    if (this.success) {
      this.success.setAttribute('aria-hidden', 'false');
      this.input.classList.add('disabled');
      this.input.blur();
      this.wrapper.classList.add('success');
      this.submit.setAttribute('disabled', 'true');
    }
  }
  
  hideError() {
    this.errorWrapper.setAttribute('aria-hidden', 'true');
    this.wrapper.classList.remove('error');
    this.submit.removeAttribute('disabled');
  }
  
  showError(errorText) {
    this.errorWrapper.setAttribute('aria-hidden', 'false');
    // check line below (was errorText = errorText ?? this.error.textContent;)
    errorText = errorText || this.error.textContent;
    this.error.textContent = errorText;
    this.wrapper.classList.remove('success');
    this.wrapper.classList.add('error');
    this.submit.setAttribute('disabled', 'true');
  }
  
  inputValidation() {
    const val = this.input.value;
    
    if (!val) return false;
    
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const result = re.test(val);
    
    if (result) {
      this.hideError();
      return true;
    } else {
      this.showError();
      return false;
    }
  }
}

customElements.define('component-newsletter', KlaviyoSubscribe);



class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('[data-accordion-content]');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => {
      (Array.from(e.target.classList).indexOf('accordion__event-prevent') > 0) ? e.preventDefault() : this.onClick(e)
    });
  }
  
  onClick(e) {
    e.preventDefault();
    var parent = e.target.closest('[data-accordion-collapseble]');
    
    if (parent) {
      parent.querySelectorAll('[data-accordion-opener][open]').forEach((el) => {
        
        if (el != this.el ) {
          const startHeight = `${el.offsetHeight}px`;
          const endHeight = `${el.querySelector('summary').offsetHeight}px`;
          
          el.animation = el.animate({
            height: [startHeight, endHeight]
          }, {
            duration: 300,
            easing: 'linear'
          });
          
          el.animation.onfinish = () => el.removeAttribute('open');
        }
      });
    }
    
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }
  
  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    
    if (this.animation) this.animation.cancel()
    
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 300,
      easing: 'linear'
    });
    
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }
  
  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }
  
  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    
    if (this.animation) this.animation.cancel()
    
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 300,
      easing: 'linear'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }
  
  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
}

document.querySelectorAll('[data-accordion-opener]').forEach((el) => {
  new Accordion(el);
});


document.addEventListener('shopify:section:load', function (event) {
  const swipers = document.querySelectorAll('swiper-slider')
  
  swipers.forEach((slider) => {
    slider.initSlider()
  })
});

// $(document).ready(function () {
//   if (!document.querySelector('body').classList.contains('Customizer'))  {
//     AOS.init({
//       duration: 800
//     });
//   }
  
//   $('.mobile-megamenu-link').on('click', function (e) {
//     e.preventDefault();
    
//     const $target = $('#' + $(this).attr('data-target'))
//     $(this).toggleClass('open')
//     $target.slideToggle()
//   })
  
//   $('.custom-select__header').off().on('click', function (e) {
//     e.stopPropagation();
//     e.preventDefault();
    
//     const $selectWrapper = $(this).parents('.custom-select')
    
//     $selectWrapper.toggleClass('opened')
    
//     if (!$selectWrapper.hasClass('custom-select--absolute')) {
//       $selectWrapper.find('.custom-select__dropdown').slideToggle()
//     }
//   })

//   $(document).on('click', '.custom-select__item', function (e) {
//     e.preventDefault()
//     const $select = $(this).parents('.custom-select')
//     const value = $(this).attr('data-text') ? $(this).attr('data-text') : $(this).attr('data-value')
//     const $productOptionSelect = $(`#${$select.attr('data-target')}`)
    
//     $productOptionSelect.val($(this).attr('data-value')).parents('variant-selects')[0]?.onVariantChange()
//     $productOptionSelect[0].dispatchEvent(new Event("change", { bubbles: true }));
    
//     $select.find('.custom-select__item').removeClass('selected')
//     $(this).addClass('selected')
//     $select.find('.custom-select__value').html(value)
    
//     if (!$select.hasClass('custom-select--absolute')) {
//       $select.find('.custom-select__dropdown').slideUp()
//     }

//     $select.removeClass('opened')
//   })
  
//   function getArticles() {
//     const $selected_tags = $('.custom-materials .materials-open-trigger, .blog-filters__facets-group')
//     let $articles = $('.blog-articles .blog-articles__article')
//     let $filteredArticles = $('.blog-articles')
//     const $noResultMessage = $('.blog__blank-message')
//     const searchValue = $('.blog-filters__search-input').val() ? [$('.blog-filters__search-input').val()] : []
//  	  $('.icon-open').removeClass('rotate')

//     if($("#materials-buttons button").length == 1) {
//        $("#materials-buttons button").hide();
//     }
    
//     if ($selected_tags.length) {
//       let attrArray = []
//       let str = ''

//       $selected_tags.each(function () {
//         let facetValue = this.querySelectorAll('input:checked')

//         console.log(facetValue)
//         if (facetValue.length) {
//           facetValue.forEach((item) => {
//             str += `<button  id="materials-tags-button"  attr="${item.value}" value="${item.value}" class="materials-buttons js-selected-facet">${item.id}<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <path class='materials-delete-icon' d="M12 4L4 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//             <path d="M4 4L12 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//             </svg></button>`
            
//             })
      
            

//           $(document).on('click', '.js-selected-facet', function() {
//             const target = $(this).attr('attr')
//             $(`button[attr="${target}"]`).remove()
//             $(`input[data-target="${target}"]`).trigger('click')
//           })
          
//           updateMaterialsTagsOutput()

//           $('.materialsinput').on('click', function() {
//            const target_reverse = $(this).attr('value')
//             if (!$(this).prop("checked") == true) {
//               $(`button[attr="${target_reverse}"]`).remove()
//             }
//           })

//           $( "#materials-tags-button" ).click(function() {
//             $(".materials-filters-facets").removeClass("opened");
//             updateMaterialsTagsOutput()
         
//           });
          
//           $(".materials-filters-facets").removeClass("opened");
          
//           $(document).on('click', '#close-all-tags', function() {
//             $("input[type=checkbox]").prop('checked',false);
//             getArticles()
            
//             $("#materials-buttons").empty()
//           });

//           if (attrArray.length) {
//              newGroupArray = [...facetValue].reduce((accum, item, metafield) => [...accum, `[data-tags*="${item.value}"]`], [])
          
//             attrArray = newGroupArray.flatMap(d => attrArray.map(v => d + v))
//           } else {
//             attrArray = [...facetValue].reduce((accum, item) => [...accum, `[data-tags*="${item.value}"]`],  [])
            
//           }
//         }
//       })


//       if (str.length) {
//       str += `<button id="close-all-tags" class="close-all-tags">Clear all</button>`
//       }
//       $('#materials-buttons').html(str)
      
//       if (searchValue.length) {
//         if (attrArray.length) {
//           attrArray = attrArray.map(item => item += `[data-search*="${searchValue.toLowerCase()}"]`)
//         } else {
//           attrArray = [`[data-search*="${searchValue.toLowerCase()}"]`]
//         }
//       }
  
//       if (attrArray.length) {
//         attrArray = attrArray.join(', ')
//         $articles.hide()
        
//         if ($filteredArticles.find(attrArray).length) {
//           $noResultMessage.hide()
//           $filteredArticles.find(attrArray).show()
//         } else {
//           $noResultMessage.fadeIn()
//         }
//       } else {
//         $noResultMessage.hide()
//         $articles.show()
//       }
//     }
//   }

//   $('.materialsinput').on('change', getArticles)
//   $('.js-blog-facet').on('change', getArticles)
//   $('.blog-filters__search-input').on('keyup', debounce(() => getArticles(), 400))

//   $('.js-show-filters').on('click', function (e) {
//     e.preventDefault();

//     bodyScrollLock.disableBodyScroll($('.blog-filters__wrapper')[0])
//     $('.PageOverlay').addClass('is-visible')
//     $('.blog-filters').attr('aria-hidden', 'false')
//   })
  
//   $('.js-close-filters').on('click', function (e) {
//     e.preventDefault();
  
//     bodyScrollLock.clearAllBodyScrollLocks()
//     $('.PageOverlay').removeClass('is-visible')
//     $('.blog-filters').attr('aria-hidden', 'true')
//   })
  
//   $(document).on('click', '.reviews-text', function () {
//     $(this).parent().find('.junip-product-summary').click()
//   })
  
//   $(document).on('contextmenu', 'img', function(e){
//     return false;
//   });
// })

$(document).ready(function () {
	if (!document.querySelector('body').classList.contains('Customizer')) {
		AOS.init({
			duration: 800
		});
	}

	$('.mobile-megamenu-link').on('click', function (e) {
		e.preventDefault();

		const $target = $('#' + $(this).attr('data-target'))
		$(this).toggleClass('open')
		$target.slideToggle()
	})

	$('.custom-select__header').off().on('click', function (e) {
		e.stopPropagation();
		e.preventDefault();

		const $selectWrapper = $(this).parents('.custom-select')

		$selectWrapper.toggleClass('opened')

		if (!$selectWrapper.hasClass('custom-select--absolute')) {
			$selectWrapper.find('.custom-select__dropdown').slideToggle()
		}
	})

	$(document).on('click', '.custom-select__item', function (e) {
		e.preventDefault()
		const $select = $(this).parents('.custom-select')
		const value = $(this).attr('data-text') ? $(this).attr('data-text') : $(this).attr('data-value')
		const $productOptionSelect = $(`#${$select.attr('data-target')}`)

		$productOptionSelect.val($(this).attr('data-value')).parents('variant-selects')[0]?.onVariantChange()
		$productOptionSelect[0].dispatchEvent(new Event("change", { bubbles: true }));

		$select.find('.custom-select__item').removeClass('selected')
		$(this).addClass('selected')
		$select.find('.custom-select__value').html(value)

		if (!$select.hasClass('custom-select--absolute')) {
			$select.find('.custom-select__dropdown').slideUp()
		}

		$select.removeClass('opened')
	})

	function getArticles() {
		const $selected_tags = $('.custom-materials .materials-open-trigger, .blog-filters__facets-group')
		let $articles = $('.blog-articles .blog-articles__article')
		let $filteredArticles = $('.blog-articles')
		const $noResultMessage = $('.blog__blank-message')
		const searchValue = $('.blog-filters__search-input').val() || ''; 

		$('.icon-open').removeClass('rotate')

		if ($("#materials-buttons button").length == 1) {
			$("#materials-buttons button").hide();
		}

		if ($selected_tags.length) {
			let attrArray = []
			let str = ''

			$selected_tags.each(function () {
				let facetValue = this.querySelectorAll('input:checked')

				if (facetValue.length) {
					facetValue.forEach((item) => {
						str += `<button id="materials-tags-button" attr="${item.value}" value="${item.value}" class="materials-buttons js-selected-facet">${item.id}<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path class='materials-delete-icon' d="M12 4L4 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 4L12 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg></button>`
					});

					$(document).on('click', '.js-selected-facet', function () {
						const target = $(this).attr('attr')
						$(`button[attr="${target}"]`).remove()
						$(`input[data-target="${target}"]`).trigger('click')
					});

					updateMaterialsTagsOutput()

					$('.materialsinput').on('click', function () {
						const target_reverse = $(this).attr('value')
						if (!$(this).prop("checked")) {
							$(`button[attr="${target_reverse}"]`).remove()
						}
					});

					$("#materials-tags-button").click(function () {
						$(".materials-filters-facets").removeClass("opened");
						updateMaterialsTagsOutput()
					});

					$(".materials-filters-facets").removeClass("opened");

					$(document).on('click', '#close-all-tags', function () {
						$("input[type=checkbox]").prop('checked', false);
						getArticles()
						$("#materials-buttons").empty()
					});

					if (attrArray.length) {
						newGroupArray = [...facetValue].reduce((accum, item) => [...accum, `[data-tags*="${item.value}"]`], [])
						attrArray = newGroupArray.flatMap(d => attrArray.map(v => d + v))
					} else {
						attrArray = [...facetValue].reduce((accum, item) => [...accum, `[data-tags*="${item.value}"]`], [])
					}
				}
			});

			if (str.length) {
				str += `<button id="close-all-tags" class="close-all-tags">Clear all</button>`
			}
			$('#materials-buttons').html(str)

			if (searchValue.length) {
				if (attrArray.length) {
					attrArray = attrArray.map(item => item += `[data-search*="${searchValue.toLowerCase()}"]`)
				} else {
					attrArray = [`[data-search*="${searchValue.toLowerCase()}"]`]
				}
			}

			if (attrArray.length) {
				attrArray = attrArray.join(', ')
				$articles.hide()

				if ($filteredArticles.find(attrArray).length) {
					$noResultMessage.hide()
					$filteredArticles.find(attrArray).show()
				} else {
					$noResultMessage.fadeIn()
				}
			} else {
				$noResultMessage.hide()
				$articles.show()
			}
		}
	}

	$('.materialsinput').on('change', getArticles)
	$('.js-blog-facet').on('change', getArticles)
	$('.blog-filters__search-input').on('keyup', debounce(() => {
		getArticles();
	}, 400));

	$('.js-show-filters').on('click', function (e) {
		e.preventDefault();

		bodyScrollLock.disableBodyScroll($('.blog-filters__wrapper')[0])
		$('.PageOverlay').addClass('is-visible')
		$('.blog-filters').attr('aria-hidden', 'false')
	})

	$('.js-close-filters').on('click', function (e) {
		e.preventDefault();

		bodyScrollLock.clearAllBodyScrollLocks()
		$('.PageOverlay').removeClass('is-visible')
		$('.blog-filters').attr('aria-hidden', 'true')
	})

	$(document).on('click', '.reviews-text', function () {
		$(this).parent().find('.junip-product-summary').click()
	})

	$(document).on('contextmenu', 'img', function (e) {
		return false;
	});
})


$(".articles-download-button").hover(mouseEnter, mouseLeave);
function mouseEnter() {
     $(this).find('path').css({'stroke': '#ffff'});
};
function mouseLeave() {
     $(this).find('path').css({'stroke': '#b8332f'});
};

$(document).ready(function() {


  if ( $('#materials-tags-output').children().length <= 0 ) {
     $('#materials-tags-output').css("min-height","0px")
}
  
  


$(".materials-open-trigger").click(function(){
  $('.icon-open').removeClass('rotate');
$(this).children().toggleClass('opened');

if ($(this).children().hasClass('opened')) {
$(this).find('.icon-open').addClass('rotate');
}
    $(".materials-filters-facets").not($(this).children()).removeClass('opened');



} )
});




$(document).ready(function() {
  var secondTagSelect = $('.materials-tags-select:eq(0)');
  $('.materials-filters-facets').children().width(secondTagSelect.width());
});

  function updateMaterialsTagsOutput() {
    const materialsButtons = document.querySelector("#materials-buttons");
    const materialsTagsButton = document.querySelector("#materials-tags-button");
    const materialsTagsOutput = document.querySelector("#materials-tags-output");
const numTagsButtons = document.querySelectorAll("#materials-tags-button").length;

const closeAllTagsButton = document.querySelector("#close-all-tags");
   
    if (closeAllTagsButton) {
      closeAllTagsButton.addEventListener("click", () => {
      materialsTagsOutput.style.maxHeight = "none";
      materialsTagsOutput.style.minHeight = "10px";
   })
    };


    if (window.innerWidth < 600 && materialsTagsOutput) {
      if (numTagsButtons > 5) {
      minHeight = "96px";
      const extraHeight = (numTagsButtons - 5) * 16;
      materialsTagsOutput.style.minHeight = `calc(${minHeight} + ${extraHeight}px)`;
    } else if (numTagsButtons > 0) {
      minHeight = "96px";
      materialsTagsOutput.style.minHeight = minHeight;
    } else if (numTagsButtons == 0) {
      minHeight = "0px";
      materialsTagsOutput.style.minHeight = minHeight;
    } else {
      materialsTagsOutput.style.minHeight = minHeight;
    }
    }
  }

$(document).on(
	'click',
	'.Drawer__CartNote__Label, .Drawer__CartNote .icon-chevron-up',
	function (e) {
		e.preventDefault();

		const $cartNote = $(this).closest('.Drawer__CartNote');
		const $wrapper = $cartNote.find('.Drawer__CartNoteWrapper');
		const isOpen = $cartNote.hasClass('is-open');

		if (isOpen) {
			$wrapper.slideUp(200);
			$cartNote.removeClass('is-open');
		} else {
			$wrapper.slideDown(200);
			$cartNote.addClass('is-open');
		}
	}
);

$(document).on('click', '.facet-filters__modal-opener-btn', function(e) {
  e.preventDefault();
  const modal = document.querySelector('modal-dialog.facets__modal');
  modal.setAttribute('aria-hidden', 'false');
  document.body.classList.add('overflow-hidden');
  trapFocus(modal);
  window.pauseAllMedia();
})

$(document).on('click', '.close-collection-modal', function(e) {
  e.preventDefault();
  const modal = document.querySelector('modal-dialog.facets__modal');
  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('overflow-hidden');
  removeTrapFocus(modal);
  window.pauseAllMedia();
})

$(document).on('click', '.facet__button-mobile-submit', function() {
  const modal = document.querySelector('modal-dialog.facets__modal');
  const form = document.querySelector('#FacetFiltersForm');
  form.dispatchEvent(new Event('change'))
  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('overflow-hidden');
  removeTrapFocus(modal);
  window.pauseAllMedia();
})


$(document).ready(function () {
	function replaceAmpersands() {
		const elements = document.querySelectorAll('*'); 

		elements.forEach((element) => {
			if (!element.children.length && element.textContent.includes(' & ')) {
				element.innerHTML = element.innerHTML.replace(/&amp;/g, '<span class="amp"> & </span>');
			}
		});
	}

	replaceAmpersands();
});